import cn from 'classnames';
import last from 'lodash/last';

import Text from 'components/common/Text';
import LightBulbIcon from 'components/icons/signUp/LightBulb';
import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';
import { DESSERTS, BREAKFASTS, SNACKS_AND_BEVERAGES } from 'lib/constants/signUp';

const FormattedAnswers = ({ answers }) => (
  <span>
    {answers.slice(0, -1).join(', ')}
    {answers.length > 1 ? <span className="text-secondary px-1">or</span> : ''}
    {last(answers)}
  </span>
);

FormattedAnswers.propTypes = {
  answers: PropTypes.array,
};

const RecommendedMealsTip = ({ boxSignupAnswers = [] }) => {
  const isTempo = useBrand(TEMPO);

  const filteredAnswers = boxSignupAnswers
    .filter(
      answer =>
        answer.selected && [DESSERTS, BREAKFASTS, SNACKS_AND_BEVERAGES].includes(answer.name)
    )
    .map(answer => answer.name);

  if (!filteredAnswers || !filteredAnswers.length) return null;

  return (
    <div
      className={cn('my-4 rounded-lg border border-solid p-2', {
        'border-charcoal-70 bg-tempo-gray-100': isTempo,
        'border-cream-120 bg-cream-110': !isTempo,
      })}
    >
      <div className="flex items-start">
        <div className="mr-2 self-center">
          <LightBulbIcon />
        </div>
        <div className="flex-1">
          <Text className="mb-1 text-left uppercase" brandStylesOverrides="h7">
            Pro Tip
          </Text>
          <Text className="text-left" brandStylesOverrides="textSm font-medium">
            Want{' '}
            <span className="text-primary lowercase">
              <FormattedAnswers answers={filteredAnswers} />
            </span>
            ? You'll be able to add them after sign up.
          </Text>
        </div>
      </div>
    </div>
  );
};

RecommendedMealsTip.propTypes = {
  boxSignupAnswers: PropTypes.array,
};

export default RecommendedMealsTip;
